document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".testimonial-track");
  const cards = document.querySelectorAll(".testimonial-card");
  let index = 0;

  const totalSlides = Math.ceil(cards.length / 2); // because we show 2 at a time

  function moveSlider() {
    index++;
    if (index >= totalSlides) index = 0;

    const offset = -index * 100; // 100% of the container
    track.style.transform = `translateX(${offset}%)`;
  }

  setInterval(moveSlider, 4000);
});
